"use client";

import "./LeagueFilterV27QuickChips.css";

export default function LeagueFilterV27QuickChips({
  quickLeagueChips,
  selectedIds,
  onQuickChipClick,
}) {
  if (!quickLeagueChips?.length) return null;

  return (
    <div className="kbv-filter-v27-chip-scroll w-full min-w-0 max-w-full">
      <div className="kbv-filter-v27-chip-strip">
        {quickLeagueChips.map((league) => {
          const label = league.nameVN || league.name || String(league.id);
          const active =
            selectedIds.length === 1 &&
            String(selectedIds[0]) === String(league.id);

          return (
            <button
              key={league.id}
              type="button"
              title={label}
              onClick={() => onQuickChipClick(league.id)}
              className={`kbv-filter-v27-chip ${active ? "kbv-filter-v27-chip--active" : "kbv-filter-v27-chip--inactive"}`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
